import View from '../core/View';
import LibraryToolbarView from './LibraryToolbarView';
import LibraryBannerView from './LibraryBannerView';
import CatalogListView from './CatalogListView';

export default class LibraryView extends View {

    createView(model) {

        let library = model['library'];
        let catalogList = model['catalogList'];

        $(document).prop('title', library.title);

        let libraryDOM = $('<div>', {
            class: 'library',
            style: `background-color: ${library.visualTemplate.listCatalogsBackgroundColor}; min-height: 100%;`
        });

        this.app.createView(new LibraryToolbarView(), {
            'library': library
        }).appendTo(libraryDOM);

        let banners = (library.visualTemplate.horizontalBanner.length > 0) ? library.visualTemplate.horizontalBanner : library.visualTemplate.verticalBanner;
        this.app.createView(new LibraryBannerView(), {
            'baseUrl': this.app.baseUrl,
            'banners': banners,
            'bannerInterval': library.visualTemplate.bannerInterval
        }).appendTo(libraryDOM);

        this.app.createView(new CatalogListView(), {
            'library': library,
            'baseUrl': this.app.baseUrl,
            'visualTemplate': library.visualTemplate,
            'catalogList': catalogList
        }).appendTo(libraryDOM);

        return libraryDOM;

    }

}